export default "__VITE_ASSET__CB6z0I2Z__"